/**
 * A global namespace for aria-pressed.
 */
const ariaPressed = "aria-pressed";
export default ariaPressed;
